import { supabase } from '@/utils/supabase/client';

interface AuditDetails {
  [key: string]: any;
}

const stringifyValue = (value: any): string => {
  try {
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value); // Serialize nested objects
    }
    return String(value); // Convert to string
  } catch (e) {
    console.warn('Error stringifying value:', value, e);
    return '[Unserializable value]'; // Fallback
  }
};

export const log_audit_action = async (
  user_id: string,
  action: string,
  resource_type: string,
  details: AuditDetails = {}
) => {
  try {
    // Sanitize details: Ensure all values are strings
    const sanitizedDetails: { [key: string]: string } = {};
    for (const key in details) {
      if (Object.prototype.hasOwnProperty.call(details, key)) {
        sanitizedDetails[key] = stringifyValue(details[key]);
      }
    }

    const { error } = await supabase
      .rpc('log_audit_action', {
        p_user_id: user_id,
        p_action: action,
        p_resource_type: resource_type,
        p_details: sanitizedDetails,
      });

    if (error) {
      console.error('Audit log failed:', error);
      throw error;
    }

    console.log(`Audit logged: ${action} by ${user_id} on ${resource_type}`);
  } catch (error) {
    console.error('Failed to log audit action:', error);
    // Don't throw - non-blocking for user experience
  }
};